export const formatData = async (donnees) => {
    const fichiers = [];

    if (donnees.justificatifs) {
        for (let i = 0; i < donnees.justificatifs.length; i += 1) {
            // eslint-disable-next-line no-await-in-loop
            fichiers[i] = await donnees.justificatifs[i].getFileToSend();
        }
    }

    return {
        motifs: donnees.motif,
        justificatifs: fichiers,
    };
};

export default formatData;
